<template>
  <div class="loading-conver" v-if="loading">
    <div class="image"></div>
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "loading",
  setup() {
    let store = useStore();

    let computeds = {
      loading: computed(() => {
        return store.getters.getLoaddingStatus;
      }),
    };

    return {
      ...computeds,
    };
  },
});
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

.loading-conver {
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  position: fixed;
  @include background_color("loading-conver-bg-color");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  z-index: 999;

  .image {
    height: 160px;
    width: 160px;
    @include background_image("loading");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}
</style>
